import { HStack, Image, Spacer } from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router";
import { useContaxt } from "../../context/Context";
import { ActionButton } from "../ActionButton";
import { BurgerMenu } from "../BurgerMenu";
import { HeaderLink } from "./HeaderLink";
import { services } from "./services";
import long_logo from "./webwerk_am_meer_logo.webp";

export function Navigation({ refs }) {
  const { color, variant } = useContaxt();
  const navigate = useNavigate();
  const location = useLocation();

  function executeScroll(ref) {
    const element = document.getElementById(ref);
    if (element) {
      const yOffset = -100;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: location?.pathname === "/" ? "smooth" : "instant",
      });
    }
  }

  return (
    <>
      <HStack
        w={"100%"}
        bg={"white"}
        h={["70px", "90px", "90px", "90px"]}
        px={[5, 7, "20px", "20px"]}
        zIndex={9999}
        position={"fixed"}
        top={0}
        borderBottomColor={color.mainColor}
        borderBottomWidth={0.3}
        boxShadow={`0px -1px 10px 2px ${color.mainColor}`}
      >
        <Image
          maxH={"80%"}
          src={long_logo}
          onClick={() => {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: location?.pathname === "/" ? "smooth" : "instant",
            });
            navigate("/");
          }}
          cursor={"pointer"}
          alt={
            "Das lange Logo der Webentwicklungs- und Webdesign Agentur WebWerk am Meer"
          }
          title="Logo der Webentwicklungs- und Webdesign Agentur WebWerk am Meer"
        />
        <Spacer />
        {variant === "lg" ? (
          <>
            {services.map((service, i) => {
              return (
                <HeaderLink
                  key={i}
                  service={service}
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      executeScroll(service.ref);
                    }, 300);
                  }}
                />
              );
            })}
            <Spacer />
            <ActionButton h={"50px"} fontSize={"13px"} />
          </>
        ) : (
          <BurgerMenu refs={refs} executeScroll={(val) => executeScroll(val)} />
        )}
      </HStack>
    </>
  );
}
